import { DissolutionUnionType } from 'shell/models/person/civil-union';
import { transformEventData } from '../event-datas-shared';
import { AccordionVoidCivilUnion } from 'shell/components/shared/sipo-person-form/new-person';

export const transformVoidCivilUnion = (
  values: AccordionVoidCivilUnion | undefined
): DissolutionUnionType | undefined => {
  const {
    eventDate,
    municipality,
    year,
    province,
    documentNumber,
    portion,
    range,
    regVol,
    office,
    documentDate,
    transcript,
  } = values || {};

  const datiEvento = transformEventData({
    eventDate,
    municipality,
    year,
    province,
    documentNumber,
    portion,
    range,
    regVol,
    office,
    documentDate,
    transcript,
  });

  const hasSentenza =
    values?.authority ||
    values?.eventDate ||
    values?.validityDate ||
    values?.number ||
    values?.courtType;

  const returnData: DissolutionUnionType | undefined = values
    ? {
        datiEvento,
        sentenza: hasSentenza
          ? {
              autorita: values?.authority || undefined,
              data: values?.eventDate?.toFormat('yyyy-MM-dd') || undefined,
              dataValidita: values?.validityDate?.toFormat('yyyy-MM-dd') || undefined,
              numero: values?.number?.toString() || undefined,
              tipoTribunale: values?.courtType || undefined,
            }
          : undefined,
        motivoScioglimento: values?.type ? Number.parseInt(values?.type) : undefined,
      }
    : undefined;

  return returnData;
};
